import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ['id', 'title', 'city', 'address', 'state', 'facilityUnitDimension', 'facilityUnitPrice'];

    connect() {}

    open() {
        //document.body.classList.add("open");
        //this.element.setAttribute("style", "display: block;");
        this.element.classList.add('show', 'd-block');
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="modal-backdrop" class="modal-backdrop fade show"></div>');
    }

    setCoHostContent(data) {
        const facility = JSON.parse(data.facility);
        this.titleTarget.innerHTML = facility.title;
        this.addressTarget.innerHTML = facility.address;
        this.cityTarget.innerHTML = facility.city;
        this.stateTarget.innerHTML = facility.state + ' ' + facility.zip;
        this.facilityUnitDimensionTarget.innerHTML = facility.facility_unit.dimension;
        this.facilityUnitPriceTarget.innerHTML = '$' + facility.facility_unit.price;
    }

    close() {
        //document.body.classList.remove("open");
        //this.element.removeAttribute("style");
        this.element.classList.remove('show', 'd-block');
        document.getElementsByClassName("modal-backdrop")[0].remove();
    }
}